<template>
  <gj-modal
    v-bind="$attrs"
    v-on="$listeners"
    :visible.sync="modalVisible"
  >
    <template #header>费用分摊</template>
    <template #content>
      <app-filter-group :reset="false">
        <gj-select
          v-model="filter.market"
          :options="[]"
          placeholder="请选择店铺"
          width="120px"
        ></gj-select>
        <gj-select
          v-model="filter.feeType"
          :options="[]"
          width="150px"
          placeholder="请选择费用类型"
        >
        </gj-select>
        <gj-date-picker
          type="month"
          v-model="filter.date"
        ></gj-date-picker>
      </app-filter-group>

      <gj-table
        :data="data"
        :columns="columns"
        :offset-height="32"
      >
        <template v-slot:op="{ row }">
          <gj-button type="text" @click.stop="sharingFee(row.id)">分摊费用</gj-button>
          <template v-if="row.sharingStatus === 1">
           <gj-button type="text" @click.stop="sharingDetail(row.id)">分摊详情</gj-button>
          </template>
        </template>
      </gj-table>
    </template>
  </gj-modal>
</template>

<script>
    import {modalMixIn} from "../../../../../minxins";
    import {sharingStatus} from "../../../../../utils/options";
    import ProfitReportSharing from './profit-report-sharing-fee';
    import SharingDetail from './sharing-detail';

    export default {
        name: "profit-report-sharing",
        mixins: [modalMixIn],
        data() {
            return {
                filter: {
                    market: null,
                    feeType: null,
                    date: new Date(),
                },
                columns: [
                    {id: 'market', header: '店铺/国家', field: 'marketName', minWidth: '120px', },
                    {id: 'feeName', header: '费用名称', field: 'feeName', minWidth: '120px', },
                    {id: 'feeAmount', header: '费用金额', field: 'feeAmount', minWidth: '120px', },
                    {id: 'sharingStatus', header: '分摊情况', field: 'option:sharingStatus', minWidth: '120px', options: sharingStatus},
                    {id: 'sharingRule', header: '分摊规则', field: 'sharingRule', minWidth: '120px', },
                    {id: 'op', header: '操作', field: 'slot:op', minWidth: '120px', notCustomColumn: true},
                ],
                data: [
                    {sharingStatus: 0,},
                    {sharingStatus: 1,},
                ],
            }
        },
        methods: {
            sharingFee(id) {
              this.$gjCreate(ProfitReportSharing)
            },
            sharingDetail(id) {
              this.$gjCreate(SharingDetail)
            }
        }
    }
</script>

<style scoped>

</style>
